module.exports = "/assets/dist/img/grad-logo.svg?49cddba40d5090b730309176d5cd59ac";


//////////////////
// WEBPACK FOOTER
// ./WebResources/vue/grad-images/site-header/svg/grad-logo.svg
// module id = 1775
// module chunks = 26